import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;

export const Header = styled.h4`
  text-align: ${(p) => (p.center ? 'center' : null)};
  font-size: ${(p) => (p.small ? '12px' : null) || (p.medium ? '18px' : null) || (p.anchor ? '16px' : null)};
  font-weight: ${(p) => (p.light ? '400' : '700')};
  margin: 10px 0;
  color: ${(p) => (p.orange ? '#E67300' : null) || (p.blue ? '#007BFF' : null)};
  cursor: ${(p) => (p.pointer ? 'pointer' : null)};
  width: 100%;
`;

export const StyledButton = styled.div`
  margin: 30px 0;
`;

export const Logo = styled.div`
  img {
    width: 230px;
    height: auto;
    margin-bottom: 2em;
}
`;

export const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  form[class*="style__Form"] {
    width: 100%;
  }

  .flex {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: baseline;
  }

  .react-tel-input {
    width: auto;

    .form-control {
      height: 100%;
      width: 100px;
    }
  }
`;

export const Divider = styled.div`
  border: 1px solid #C2CDDD;
  width: 100%;
  margin: 20px 0 5px;
`;

export const Text = styled.p`
  display: inline-block;
  font-size: ${(p) => (p.small ? '10px' : null) || (p.medium ? '16px' : null)};
  text-align: ${(p) => (p.justify ? 'justify' : null)};
  color: ${(p) => (p.orange ? '#E67300' : null) || (p.blue ? '#007BFF' : null)};
  cursor: ${(p) => (p.pointer ? 'pointer' : null)};
  white-space: ${(p) => (p.lineBreak ? 'pre-line' : null)};
  font-weight: ${(p) => (p.bold ? '700' : '400')};
`;

export const TermsAndConditionsWrapper = styled.div`
      width: 700px;
      .title {
      text-align: center;  
      }
      .info {
        font-size: 8px;
      }
      @media screen and (max-width: 425px) {
        width: 100%;
        height: auto;
      }
`;

export const FlexBox = styled.div`
     display: flex;
     gap: 10px;
     margin-top: 10px;
`;
